var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.93359 18.1328H3.22266C3.57865 18.1328 3.86719 17.8443 3.86719 17.4883V11C3.86719 10.644 3.57865 10.3555 3.22266 10.3555H1.93359C0.865734 10.3555 0 11.2212 0 12.2891V16.1992C0 17.2671 0.865734 18.1328 1.93359 18.1328ZM20.0664 10.3555H18.7773C18.4213 10.3555 18.1328 10.644 18.1328 11V18.7773C18.1328 19.133 17.8439 19.4219 17.4883 19.4219H14.1469C13.8799 18.6733 13.1713 18.1328 12.332 18.1328H9.71094C8.64475 18.1328 7.77734 19.0003 7.77734 20.0664C7.77734 21.1325 8.6448 22 9.71094 22H12.332C13.1713 22 13.8799 21.4595 14.1469 20.7109H17.4883C18.5545 20.7109 19.4219 19.8435 19.4219 18.7773V18.1328H20.0664C21.1343 18.1328 22 17.2671 22 16.1992V12.2891C22 11.2212 21.1343 10.3555 20.0664 10.3555ZM1.31845 9.12871C1.51783 9.08991 1.72296 9.06641 1.93359 9.06641H3.22266C3.45933 9.06641 3.68358 9.11509 3.8934 9.19329C4.15938 5.52032 7.25901 2.57812 11 2.57812C14.741 2.57812 17.8406 5.52032 18.1066 9.19329C18.3164 9.11509 18.5407 9.06641 18.7773 9.06641H20.0664C20.277 9.06641 20.4822 9.08991 20.6815 9.12871C20.3789 4.06184 16.1428 0 11 0C5.85716 0 1.62108 4.06188 1.31845 9.12871Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.fcb07bf5273705c623a4cd4dd1d66196.svg";
export { ForwardRef as ReactComponent };